<!--
  OrderDetailDialog -- Client Portal "View full order" overlay.

  A thin Vuetify v-dialog wrapper around the presentational OrderDetailView.
  It passes ONLY client-safe fields taken from the /api/portal/orders
  per-order payload (order #, status, date, shopper, department, store, line
  items + client price, shipping, totals). It NEVER passes distributor-
  internal data -- the portal endpoint does not return margin / cost /
  app_fee / TF cut, and OrderDetailView has no surface to render them anyway
  (defense in depth: safe source + safe renderer).

  No fetching happens here: the Orders list already holds the full per-order
  payload, so the dialog just displays the row the user clicked. This avoids
  a second endpoint round-trip (spec: prefer reusing the list payload).
-->
<template>
  <v-dialog
    :model-value="modelValue"
    max-width="640"
    scrollable
    data-testid="portal-order-dialog"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card v-if="order">
      <v-card-title class="d-flex align-center">
        <span>Order details</span>
        <v-spacer />
        <v-btn
          icon="close"
          variant="text"
          size="small"
          data-testid="portal-order-dialog-close"
          @click="close"
        />
      </v-card-title>
      <v-card-text>
        <!-- Do NOT set data-testid here: OrderDetailView owns
             data-testid="order-detail-view" on its root, and a parent-passed
             attr would override it via attribute fallthrough. -->
        <OrderDetailView :order="order" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <PortalButton
          variant="ghost"
          size="sm"
          data-testid="portal-order-dialog-done"
          @click="close"
        >
          Close
        </PortalButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OrderDetailView from "@/components/Order/OrderDetailView.vue";
import PortalButton from "@/components/portal/PortalButton.vue";

export default {
  name: "OrderDetailDialog",
  components: { OrderDetailView, PortalButton },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    // The client-safe order object (a row from /api/portal/orders). Passed
    // straight through to OrderDetailView. May be null while closed.
    order: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    },
  },
};
</script>
